export const BusinessModelEnum = {
  Depot: 1,
  Service: 2,
  Courier: 3,
}

export type BusinessModel = typeof BusinessModelEnum[keyof typeof BusinessModelEnum]
